import { Link as MLink, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export const components = {
  p: ({ node, ...props }) => <Typography variant="body1" mb={1} {...props} />,
  a: ({ node, ...props }) =>
    props.href.startsWith("mailto:") ? (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      <a {...props} />
    ) : (
      <MLink component={Link} to={props.href} underline="hover" {...props} />
    ),
  h1: ({ node, ...props }) => (
    <Typography variant="h2" component="h1" {...props} sx={{ paddingTop: 2 }} />
  ),
  h2: ({ node, ...props }) => (
    <Typography variant="h3" component="h2" {...props} sx={{ paddingTop: 2 }} />
  ),
  h3: ({ node, ...props }) => (
    <Typography
      variant="h4"
      component="h3"
      {...props}
      sx={{ paddingTop: 1.5 }}
    />
  ),
  h4: ({ node, ...props }) => (
    <Typography variant="h5" component="h4" {...props} sx={{ paddingTop: 1 }} />
  ),

  img: ({ node, ...props }) => (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img src={process.env.PUBLIC_URL + props.src} width="100%" {...props} />
  ),
};
